import { Locale, formatDistance } from 'date-fns';
import { da, de, es, fi, fr, it, nb, nl, pt, sv } from 'date-fns/locale';
import { getLanguageCode } from '@99designs/i18n';
import { usePage } from '@99designs/tracking';

type Arg1 = Parameters<typeof formatDistance>[0];
type Arg2 = Parameters<typeof formatDistance>[1];
type Arg3 = Parameters<typeof formatDistance>[2];

const localeMap: Record<string, Locale> = {
    da: da,
    de: de,
    es: es,
    fi: fi,
    fr: fr,
    it: it,
    nb: nb,
    nl: nl,
    pt: pt,
    sv: sv,
};

type FormatDistance = typeof formatDistance;

export default function useFormatDistance(): FormatDistance {
    const page = usePage();
    const lang = getLanguageCode(page.locale).toLowerCase();

    return function (date: Arg1, baseDate: Arg2, options?: Arg3) {
        return formatDistance(date, baseDate, {
            locale: localeMap[lang] || undefined,
            ...options,
        });
    };
}
